import style from './Popup.css';
import CrossIcon from '../Icons/CrossIcon';
import { useEffect } from 'preact/hooks';
import Title from '../Typography/Title';
import BodyText from '../Typography/BodyText';
import Button from '../Button/Button';
import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';

export default function Popup({
  className = '',
  onCloseClick,
  title = '',
  subtitle = '',
  primaryCta = {},
  secondaryCta = {},
  showing = false,
  icon,
  ...props
}) {
  useEffect(() => {
    document.querySelector('html').style.overflow = showing ? 'hidden' : 'auto';
  }, [showing]);

  useEffect(() => {
    return () => {
      document.querySelector('html').style.overflow = 'auto';
    };
  }, []);

  const { text: mainCtaText, ...mainCtaProps } = primaryCta;

  const { text: secondaryCtaText, ...secondaryCtaProps } = secondaryCta;
  return (
    <div className={`${style.overlay} ${_className(showing, style.showing)} `}>
      <div
        className={`${className} ${style['popup']} ${_className(
          showing,
          style['showing'],
        )}`}
        {...props}
      >
        <div className={style.header}>
          <button
            className={style['icon-button']}
            onClick={onCloseClick}
            data-testid="popup-close-icon"
          >
            <CrossIcon />
          </button>
        </div>
        <div className={style.body}>
          {renderIf(
            icon,
            <div className={style['popup-icon']}>
              <img src={icon} width={120} height={120} />
            </div>,
          )}

          <div className={style.content}>
            {renderIf(
              title,
              <Title text={title} className={style['popup-title']} />,
            )}

            {renderIf(
              subtitle,
              <BodyText text={subtitle} className={style['popup-subtitle']} />,
            )}
          </div>
        </div>
        <div className={style.actions}>
          <Button {...mainCtaProps}>{mainCtaText}</Button>

          {renderIf(
            secondaryCtaText,
            <Button
              {...secondaryCtaProps}
              type="tertiary"
              className={style['secondary-cta']}
            >
              {secondaryCtaText}
            </Button>,
          )}
        </div>
      </div>
    </div>
  );
}
